// extracted by extract-css-chunks-webpack-plugin
module.exports = {"unclickable":"download-link__unclickable--3zksF","link":"download-link__link--23utW","wrapper":"download-link__wrapper--1L6E4"};